/**
 * MMTG binary format constants. Spec: metro-frontend/MMTG_FORMAT.md.
 *
 * These MUST stay in lock-step with the authoritative copies in
 * metro-server / metro-ios / metro-android. Version bumps require an
 * atomic cross-repo PR bundle (see MMTG_FORMAT.md "Atomic update rule").
 */

export const MMTG_MAGIC = [0x4d, 0x4d, 0x54, 0x47] as const // "MMTG"

export const MmtgElementType = {
  Connections: 1,
  Stations: 2,
  Additionals: 3,
  Transitions: 4,
  Texts: 5,
} as const
export type MmtgElementType = (typeof MmtgElementType)[keyof typeof MmtgElementType]

export const CURRENT_VERSIONS: Record<MmtgElementType, number> = {
  [MmtgElementType.Connections]: 1,
  [MmtgElementType.Stations]: 1,
  [MmtgElementType.Additionals]: 1,
  [MmtgElementType.Transitions]: 1,
  [MmtgElementType.Texts]: 1,
}

/** Interleaved `[x, y, r, g, b, a]` — matches metro-android `Tessellator` output. */
export const FLOATS_PER_VERTEX = 6
export const BYTES_PER_VERTEX = FLOATS_PER_VERTEX * 4

/** `flags` bit 0 — entry persisted for on-demand use, not drawn on base map. */
export const FLAG_SKIP_INITIAL_DRAW = 1 << 0

/**
 * `flags` bit 1 — drawn on the base map, never lifted by a route highlight:
 * a visible transfer's whole interchange (MMTG_FORMAT.md "flags").
 */
export const FLAG_BASE_ONLY = 1 << 1

/** Fixed header size in bytes: magic(4) + elementType(4) + version(4) + signature(8) + count(4). */
export const HEADER_SIZE = 24
